function useStateContextCallbacks() {
    return {
        updateGcmConsentTypeChecked: (param, type, checked)=>{
            let { gcmConsent } = param;
        /* Silence is golden... Until you have PRO Version! */ }
    };
}
export { useStateContextCallbacks };
